import { NgModule } from '@angular/core';
import { HeadingComponent } from './heading.component';

@NgModule({
  declarations: [
    HeadingComponent,
  ],
  exports: [
    HeadingComponent,
  ],
})
export class HeadingModule {}



// WEBPACK FOOTER //
// ./src/app/common/components/HeadingComponent/heading.module.ts